import { WDD } from '../core/wdd.js';

export function injectSVGSprite(path = "https://image.alza.cz/Foto/or/bp/oppo/x10/img/sprite.svg") {
    if (window.location.hostname === "127.0.0.1") path = "build/img/sprite.svg";

    if (!WDD.svg) WDD.svg = { cache: {}, promise: null };
    else if (WDD.svg.promise) return WDD.svg.promise;

    WDD.svg.promise = (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 5000);

        try {
            const response = await fetch(path, { signal: controller.signal });
            clearTimeout(timer);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const dom  = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
            const uses = Array.from(WDD.el.querySelectorAll("use"));

            dom.querySelectorAll('symbol').forEach(symbol => {
                const viewBox = symbol.getAttribute('viewBox')?.trim();
                const size    = viewBox ? viewBox.split(/\s+/).map(Number) : null;
                const useEls  = uses.filter(use =>
                    use.getAttribute('href')       === `#${symbol.id}`
                    || use.getAttribute('xlink:href') === `#${symbol.id}`
                );

                useEls.forEach((useEl, i) => {
                    const svg = useEl.closest("svg");
                    if (!svg) return;

                    // Set width and height from viewBox if not already present in HTML
                    if (size?.length === 4) {
                        const [, , w, h] = size;
                        if (!svg.hasAttribute('width'))  svg.setAttribute('width', w);
                        if (!svg.hasAttribute('height')) svg.setAttribute('height', h);
                    }

                    // Copy attributes from <symbol> to <svg>, excluding id and already-set attributes
                    Array.from(symbol.attributes)
                        .filter(attr => attr.name !== 'id' && !svg.hasAttribute(attr.name))
                        .forEach(attr => svg.setAttribute(attr.name, attr.value));

                    // Rename internal IDs before inserting into DOM to prevent duplicates
                    let content = symbol.innerHTML;

                    // Pass 1: rename id="..." declarations and build the old→new mapping
                    const idMap = new Map();
                    content = content.replace(/\bid="([^"]+)"/g, (_, oldId) => {
                        const newId = `wdd_${symbol.id}_${i}_${idMap.size}`;
                        idMap.set(oldId, newId);
                        return `id="${newId}"`;
                    });

                    // Pass 2: update all references (url(#id), href="#id") in one combined regex
                    if (idMap.size > 0) {
                        const ids = [...idMap.keys()].map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
                        content = content.replace(
                            new RegExp(`(url\\(#|(?:xlink:)?href=["']#)(${ids.join('|')})(?=[)"'])`, 'g'),
                            (_, prefix, oldId) => prefix + idMap.get(oldId)
                        );
                    }

                    svg.innerHTML = content;

                    // Cache the first instance as a reference clone
                    if (!i) WDD.svg.cache[symbol.id] = svg.cloneNode(true);
                });
            });

            return WDD.svg.cache;
        } catch (error) {
            clearTimeout(timer);
            console.error("SVG sprite error:", error);
            throw error;
        }
    })();

    return WDD.svg.promise;
}
